var CheckoutV2 = function( config ) {
	var checkout = this;

	checkout.config = $.extend({
		version: 7,
        endpoint: "",
        shipQuoteEndpoint: "",
		siteAbbr: "",
		siteName: "",
		siteNameFirstWord: "",
		contactInfo: {
			email: "",
			phone: "",
			phoneExtra: "",
			liveChatHref: "",
		},
		sessionInit: {},
		user: "",
		wireTransferFee: 0,
		productAdminEditURL: "",
		instoreTaxRate: 0,
		instoreShippingGroups: {},
		instoreShippingServices: {},
		paypalError: undefined,
		affirmError: undefined,
		bsPopoverData: 'popover',
		cartItemProdIDKey: "productID",
		cartItemCount: '.cart .badge',
		isEndeca: 0,
		suggestions: 1,
		prodImgSize: {
			small: 100,
			large: 300,
		},
		zipContainer: '#shipping_zip_container',
		isV2Checkout: 1,
		saveForLater: 1,
		debug: 0,
		urlTerminator: '/',
		useLargeFont: false,
        onCartProceed: function(){},
		promoCodeEnabled: 1,
	}, config);

    if (!checkout.config.endpoint) {
        console.error('endpoint required');
    }

    if (!checkout.config.shipQuoteEndpoint) {
        console.error('shipQuoteEndpoint required');
    }

	this.$loadingOverlay = $('.js-overlay-full-screen');
	this.$loadingMsg = this.$loadingOverlay.find('.msg-text');
	
    this.$fullHeader   = $( ".js-full-header" );
    this.$fullFooter   = $( ".js-full-footer" );
    this.$skinnyHeader = $( ".js-skinny-header" );
    this.$skinnyFooter = $( ".js-skinny-footer" );

    this.isHistoryChange = false;
    this.step = -1;
    this.$nextStep = $( ".js-next-step" );
	
	this.beforeModalPos = -1;
	
	this.numericKeys = false;
	this.floatKeys = false;
	this.specialKeys = [ 8, 9, 13, 16, 37, 39, 46 ];;

	this.steps = [
		'cart',
		'shipinfo',
		'shipping',
		'payment',
		'review',
		'submit'
	];
    this.$steps = [
        $( ".js-cart-contents" ),
        $( ".js-shipping-address" ),
        $( ".js-shipping-options" ),
        $( ".js-payment" ),
        $( ".js-review" ),
    ];
    this.$progress = $( ".js-progress" );
    this.$stepProgress = [
        $( ".js-progress-cart" ),
        $( ".js-progress-shipping" ),
        $( ".js-progress-shipping" ),
        $( ".js-progress-payment" ),
        $( ".js-progress-review" ),
    ];
    this.stepHandlers = {};
	this.afterStepHandlers = {};
    this.stepLabels = [
        '<i class="fa fa-lock" aria-hidden="true"></i> Checkout',
        'Shipping Options <i class="fa fa-arrow-right"></i>',
        'Payment <i class="fa fa-arrow-right"></i>',
        'Review Order <i class="fa fa-arrow-right"></i>',
        'Place Order',
    ];
    this.stepCTAs = [
        'checkout',
        'shipping',
        'payment',
        'review',
        'submit',
    ];

	this.paypalErrorMsg = (
		'There was an error contacting PayPal. Please try your request again.<br />'
		+ 'If this error continues please contact ' + checkout.config.siteName + ' Sales for support.'
	);
	this.affirmErrorMsg = (
		'There was an error contacting Affirm. Please try your request again.<br />'
		+ 'If this error continues please contact ' + checkout.config.siteName + ' Sales for support.'
	);

	this.user = config.user;
	this.delayTimers = {};
	this.shippingServiceCode = false;
	this.shippingCouriers = false;
	this.shippingServices = false;
	this.shippingRates = {};
	Object.defineProperty(this, 'shippingServiceGroupID', {
		get: function() {
			return this._shippingServiceGroupID;
		},
		set: function(gid) {
			this._shippingServiceGroupID = gid;
		}});
	this._shippingServiceGroupID = false;
	this.shippingServiceGroupRates = {};
	this.shippingMultiLocations = 0;
	this.smartCartEligible = 0;
	this.isDomestic = false;

	this.session = false;
	this.remote = false;

	this.log;
	this.cart = false;
	this.shipping = false;
	this.login = false;
	this.shipinfo = false;
    this.billinfo = false;
	this.payment = false;
	this.suggestions = false;
	this.cameFromRedirect = false;

	this.$submit = $('#checkout-submit');

	this.$submitIcon = $('#checkout-submit-icon');
	this.$submitIconLoading = $('#checkout-submit-icon-loading');

    // Array of functions for next step calls when the step fails
    // and returns false from its step handler
    // fired by onStepFailed
    this._stepFailedListeners = [];

    this.registerStepFailedListener = function(fn) {
        checkout._stepFailedListeners.push(fn);
    };

    this.removeStepFailedListener = function(fn) {
        checkout._stepFailedListeners = checkout._stepFailedListeners.filter(function(listener) {
            return listener !== fn;
        });
    };

    this._callStepFailedListeners = function() {
        checkout._stepFailedListeners.forEach(function(fn) {
            fn();
        });
    };

    // Array of functions for next step calls when the step succeeds
    // fired by onStepChanged
    this._stepChangedListeners = [];

    this.registerStepChangedListener = function(fn) {
        checkout._stepChangedListeners.push(fn);
    };

    this._callStepChangedListeners = function() {
        checkout._stepChangedListeners.forEach(function(fn) {
            fn();
        });
    };

    // Returns the review step 'next step' button html
    this.getReviewStepButtonHtml = function() {
		return checkout.stepLabels[3];
	};

    // Returns the review step cta button id
    this.getReviewStepCTA = function() {
		return checkout.stepCTAs[3];
	};

    // Flags for reacting on the step changed event.
	// If a flag is set to true, it's value will be set to false and the action run
    this.showEditShipping = false;

    // Listener for step changed. Fires after a step has successfully changed
    this._onStepChanged = function() {
        var $covidNotices = $('.js-covid-notice');
    	if(checkout.currentStepName() !== 'cart') {
            $('.promotions').hide();
            $covidNotices.attr('style', 'display: none !important');
            if (checkout.config.promoCodeEnabled) {
                checkout.cart.promos.clearNotifications();
            }
        } else {
            $('.promotions').show();
            $covidNotices.removeAttr('style');
        }

      // Hide available balances if this isn't the payment step
    	if(checkout.currentStepName() !== 'payment'){
            checkout.payment.hideAvailableBalances();
		}
        // Show the edit shipping modal if review sent us back
        if(checkout.showEditShipping) {
            checkout.showEditShipping = false;
            if (checkout.session.isLoggedIn()) {
                $('#selectAddressModal').modal('show');
            } else {
                checkout.shipping.prefillAddEditAddressForm();
                checkout.shipping.$addEditAddressModal.modal('show');
            }
        }
        // Clear the cameFromRedirect flag since we are forced out of review and back through the
		// checkout flow. This flag is needed to deal with balances syncing during the totals update
		// when we come back from a 3rd party redirect
		if(checkout.currentStepName() !== 'review') {
            checkout.cameFromRedirect = false;
            $('.js-disclaimer-links').hide();
		} else {
            $('.js-disclaimer-links').show();
        }

        // Disable all future steps of the current step;
		switch (checkout.currentStepName()) {
			case 'shipping':
                $('.js-progress-payment')
                    .removeClass( "current" )
                    .removeClass( "active" )
                    .unbind( "click" );
                $('.js-progress-review')
                    .removeClass( "current" )
                    .removeClass( "active" )
                    .unbind( "click" );
				break;
			case 'payment':
                $('.js-progress-review')
                    .removeClass( "current" )
                    .removeClass( "active" )
                    .unbind( "click" );
				break;
		}
	};

	this.init = function() {
		checkout.numericKeys = checkout.keyRange();
		checkout.floatKeys = checkout.keyRange(true);
		
		checkout.shouldUseLargeFont();
		checkout.listen();
		checkout.registerStepChangedListener(checkout._onStepChanged);
		
		checkout.log = new CheckoutV2.Log(checkout);
		checkout.remote = new Checkout.Remote(checkout);
		checkout.session = new CheckoutV2.Session(checkout);

        checkout.billinfo = new CheckoutV2.BillInfo(checkout, '.billing-address-modal .js-address-form.js-billing');

		checkout.cart = new CheckoutV2.Cart(checkout);
        checkout.payment = new CheckoutV2.PaymentV2(checkout);
        checkout.review = new CheckoutV2.ReviewV2(checkout);
        checkout.paypalCheckout = new CheckoutV2.PayPalCheckout(checkout);
        checkout.braintreePayPalCheckout = new CheckoutV2.BraintreePayPalCheckout( checkout, { credit: false } );
        checkout.braintreePayPalCreditCheckout = new CheckoutV2.BraintreePayPalCheckout( checkout, { credit: true } );
		checkout.suggestions = new CheckoutV2.Suggestions(checkout);
		checkout.globals = new Checkout.Globals( checkout );
		checkout.stepHandlers = {
			'cart'            : this.setCart,
			'shipinfo'        : this.setShippingAddress,
			'shipping'        : this.setShipping,
			'payment'         : this.setPayment,
			'review'          : this.setReview,
			'submit'          : this.setSubmitOrder,
		};
		checkout.afterStepHandlers = {
			'cart'            : this.setAfterCart,
			'shipping'        : this.setAfterShipping,
		};
		checkout.$nextStep.html( checkout.stepLabels[ 0 ] );
		
		// Check if we are returning from PayPal or Affirm and need to go to review
		if (checkout.session.get('reviewPayment') == 1) {
			checkout.cameFromRedirect = true;
			checkout.session.set({'reviewPayment' : 0});
			checkout.session.set({'requestReviewPayment' : 0});

            // Set the payment modules payment to the proper third party type
			if(parseFloat(checkout.session.get('PayPalConfirmed')) > 0) { //initPaypalPayment === 1
                checkout.payment.setMethodByName('paypal');
			} else if(parseFloat(checkout.session.get('affirmConfirmed')) > 0) { //initAffirmPayment
                checkout.payment.setMethodByName('affirm');
			}

			// Render the shipinfo container and do some work on it to make the loader look nicer
			// When shipinfo gets better, we can do this right
			// TODO: fix shipinfo so that this doesn't have to happen.
			var $shipInfoContainer = $('.shipping-address.js-review.shipping-address');
            $shipInfoContainer.find('.section-content').html(
                Jemplate.process('includes/partials/shippingInfo.html', {})
            );
            $shipInfoContainer.find('.address-display').addClass('fade');
            $shipInfoContainer.find('.ship-date-display').addClass('fade');
            $shipInfoContainer.find('.loading-overlay').show();
            // hide "OR checkout with paypal"  mobile
            $('.paypal-option,.paypal-credit-option').hide();
            // hide original paypal checkout button
            $('.js-cart-contents.paypal-option').hide();
            $('#leftWrap').hide(); // tms
            checkout.review.showLoading();

            checkout.step = 3;
            checkout.nextStep(false, 4);
        } else {
			checkout.nextStep(true, 0);
		}
	};

	// This is fired when the shipping quote request completes in cart.shipping
	// Prior to the completed request, shipinfo doesn't have any data to render
	this.onShippingQuoteResponse = function() {
		// This only needs to fire if we came from a third party payment redirect.
		if(checkout.cameFromRedirect) {
            var shippingServiceCode = checkout.session.get( "shippingServiceCode" );
            if( shippingServiceCode ) {
                var shippingMethod;
                $.each( checkout.shipping.shippingResponse.services, function( code, method ) {
                    if ( code == shippingServiceCode ) {
                        shippingMethod = method.name;
                    }
                } );

                if( shippingMethod ) {
                    checkout.shipping.changeService( shippingServiceCode, shippingMethod );
                }
            }

            checkout.review.hideLoading();
            checkout.shipinfo = new CheckoutV2.ShipInfo(
                checkout,
                '.js-shipping-address .js-address-form.js-shipping',
                true
            );
            checkout.shipinfo.setFormDataFromSession();
		}
	};
	
	this.listen = function() {

		checkout.$submit.click(function() {
			checkout.submit();
		});
		
		checkout.$loadingOverlay.on('animationend webkitAnimationEnd MSAnimationEnd', function(e) {
			var $this = checkout.$loadingOverlay;
			if ($this.hasClass('fade-out')) $this.hide();
		});

		$(document).click(function(e) {
			var $target = $(e.target || e.srcElement),
				targetStep = $target.parents('section').data('step');

			if (
				$target.attr('id') != 'checkout-submit'
				&& !checkout.session.saved(targetStep)
			)
				checkout.session.save();
		});

		// Integer Only Input
		$('.intonly').keydown(checkout.intOnly);
		$('.floatonly').keydown(checkout.floatOnly);

		// Override bootstrap alert-close behavior (fadeOut/hide instead of remove)
		$('.alert').bind('close', function(e) {

			e.preventDefault();
			var $alert = $(this);

			$alert.fadeOut(function() {
				$alert.find('.msg-text').html('');
			});

		});

		checkout.$nextStep.click( function() {
            if ( checkout.step == 2 && checkout.shipping.inStorePickup ) {
                checkout.shipping.$pickupModal.modal('show')
            } else {
                checkout.nextStep();
            }
		} );
		
		$(document).on('show.bs.modal', '.modal', function () { // hack to handle modal stacking
			var zIndex = 1040 + (10 * $('.modal:visible').length);
			$(this).css('z-index', zIndex);
			setTimeout(function() {
				$('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
			}, 0);
			checkout.beforeModalPos = $(document.activeElement).offset().top;
		});
		
		$(window).on('popstate', function(event) {
			checkout.isHistoryChange = true;
			var state = event.originalEvent.state;

			if (state) {
				// Go back to the cart if we just tried to navigate to step 1 from step 2.
				// This happens when we already have a saved address, as step 1 loads step 2 automatically
                if(checkout.shipinfo.valid && state.step === 1) {
                    checkout.nextStep( false, 0);
				}
				else{
                	// Do not allow skipping steps. Must always be +/- 1 step from current to move.
                	if(state.step === checkout.step + 1 || state.step === checkout.step - 1) {
                        checkout.nextStep( false, state.step );
					}
				}
			}
			else{
				window.history.back();
			}
			return false;
		});
	};
	
	this.pushState = function(step) {
		var state = { step: step },
			title = document.title,
			path  = window.location.pathname + window.location.search;

		window.history.pushState(state, title, path);
	};

	this.submit = function(onFail, initPaypalPayment, initAffirmPayment) {
		//console.log('p1');
		var onFails = [function() {
				checkout.$submit.removeAttr('disabled');
				checkout.$submit.find('.btn-text').html('Place Order');
				checkout.$submitIcon.show();
				checkout.$submitIconLoading.hide();
			}],
			firstInvalidStep = false;

		if (onFail)
			onFails.push(onFail);

		checkout.session.setAllData();

        //console.log('p2');

		var session = checkout.session.get();

		session.cartItems = checkout.cart.getItemData();
		session.totals = checkout.cart.totals.values;
		session.totals.taxRate = checkout.cart.totals.taxRate;

        //checkout.loading("Submitting Order...");
        checkout.payment.getActivePaymentMethodsForSubmit( function( methods ) {
            // Set the payment info in the session from the payment module
            // Not sure why we need both, but we do.
            session.payments = methods;
            session.paymentMethods = methods;

            // Set the billing ID for the checkout submit. For things like paypal and affirm this should be false
            session.billID = checkout.payment.getBillId();
            session.billing = checkout.payment.getBillInfoForSubmit();

            // Third party payments need special session variables set for the redirect
            if(checkout.payment.hasThirdPartyPayment){
                if(checkout.payment.thirdPartyPaymentType === 'paypal') {
					checkout.loading('Sending you to PayPal...');
                    session.initPaypalPayment = 1;
					session.initAffirmPayment = 0;
                } else if(checkout.payment.thirdPartyPaymentType === 'affirm') {
                    checkout.loading('Sending you to Affirm...');
					session.initPaypalPayment = 0;
                    session.initAffirmPayment = 1;
                }
				
                // Flag needed to tell the server to get the redirect
                session.requestReviewPayment = 1;
                // Flag needed to restore shipping data on the redirect back
                session.shippingServiceGroupSet = 1;
            }
            else { // Actual order submit, clear the third party init vars
				checkout.loading("Submitting Order...");
                session.initPaypalPayment = 0;
				session.initAffirmPayment = 0;
            }

            if (checkout.shippingServiceGroupID) {
                session.shippingServiceGroupID = checkout.shippingServiceGroupID;
            } else {
                delete session.shippingServiceGroupID;
            }
            session.shippingServiceCode = checkout.shippingServiceCode;
            session.smartCartEligible = checkout.smartCartEligible || 0;

            // Order Submit saves the session
            $.each(checkout.steps, function(i, step) {
                if (checkout[step])
                    checkout[step].saved = true;

            });

            var submission = new CheckoutV2.Submit(checkout, {
                'onFails' : onFails
            });
            
            if (checkout.config.saveForLater) {
                checkout.cart.saveForLater.syncWishList();
            }

            if(!session.billing.phone || session.billing.phone === ''){
               session.billing.phone = checkout.shipinfo.getFormData().shipping.phone;
            }
            if(!session.billing.email || session.billing.email === ''){
               session.billing.email = checkout.shipinfo.getFormData().shipping.email;
            }
                    
            submission.submit({
                'step'   : 'submit',
                'action' : 'submit',
                'data'   : encodeURIComponent(JSON.stringify(session)),
                'options': encodeURIComponent(JSON.stringify( { 'newSite': checkout.config.isEndeca, 'isV2Checkout': checkout.config.isV2Checkout } )),
            });
        } );
	};

	// Checkout Global Utils

	this.alignMiddle = function($child, $parent) {
		$child.css('margin-top', ($parent.height() / 2) - ($child.height() / 2));
	};

	this.delayChange = function($el, time, done) {
		if (checkout.delayTimers[$el])
			clearTimeout(checkout.delayTimers[$el]);

		checkout.delayTimers[$el] = setTimeout(done, time);
	};

	this.scrollToInvalidStep = function(step) {
		checkout.nextStep(false, checkout.stepNumberByName(step));
	};

	this.scrollToCenter = function($el) {
		var viewportHeight = jQuery(window).height(),
			elHeight = $el.height(),
			elOffset = $el.offset();

		$('html,body').animate(
			{ 'scrollTop': (elOffset.top + (elHeight/2) - (viewportHeight/2)) },
			250
		);
	};

	this.intOnly = function(e) {
		var code = (e.keyCode ? e.keyCode : e.which),
			codeStr = code + '';

		// control keys are allowed
		if (codeStr.match(/^(8|9|13|16|17|18|20||27|33|34|37|38|39|40|46)$/))
			return true;

		// numbers above letters are allowed
		if (code >= 48 && code <= 57)
			return true;

		// numberpad numbers are allowed
		if (code >= 96 && code <= 105)
			return true;

		return false;
	};

	this.floatOnly = function(e) {
		var code = (e.keyCode ? e.keyCode : e.which),
			codeStr = code + '';

		// control keys are allowed
		if (codeStr.match(/^(8|9|13|16|17|18|20||27|33|34|37|38|39|40|46)$/))
			return true;

		// numbers above letters are allowed
		if (code >= 48 && code <= 57)
			return true;

		// numberpad numbers are allowed
		if (code >= 96 && code <= 105)
			return true;

		// decimal/period is allowed
		if (code == 190 || code == 110)
			return true;

		return false;
	};

	this.switchCheckoutVersion = function(v) {
		checkout.remote.call({
			'type': 'POST',
			'data': {
				'step': 'session',
				'action': 'switchCheckoutVersion',
				'checkoutVersion': v
			}
		})
		.done(function() {
			window.location.reload(true);
		});
	};

    this.nextStep = function( overrideStepHandler, nextStep ) {
		// move forwards one step by default
        if( typeof nextStep == "undefined" ) nextStep = checkout.step + 1;
        var lastStep = checkout.step;

        if( nextStep == lastStep ) return;

        var nextStepName  = checkout.steps[ nextStep ];
		
		// update the total for affirm, hide the payment type if affirm is ad-blocked
		if (nextStepName == 'payment' && affirm && affirm.ui && affirm.ui.payments && affirm.ui.payments.get_estimate) {
			updateAffirmRate();
		} else {
			$('.affirmLoanCheck').hide();
		}
		
        var nextStepHandler = checkout.stepHandlers[ nextStepName ];
        if( ! overrideStepHandler
            && nextStepHandler
            ) {
            // if the next step handler returned false, stay on this step
            if(!nextStepHandler.call(checkout)){
                checkout._callStepFailedListeners();
                return;
			}
        }

        var $lastStep = checkout.$steps[ lastStep ];
        var $nextStep = checkout.$steps[ nextStep ];
        var $lastProgress = checkout.$stepProgress[ lastStep ];
        var $nextProgress = checkout.$stepProgress[ nextStep ];

        checkout.config.onCartProceed($lastStep, $nextStep);

        checkout.step = nextStep;
        if(!checkout.isHistoryChange){
            checkout.pushState(nextStep);
        }
        checkout.isHistoryChange = false;

        $nextStep.each( function( i, container ) {
            var $container = $( container );
            if( ! $container.hasClass( "js-hide" ) )  $container.show();
        } );

        if( $lastStep) {
            $lastStep.hide();
            $lastProgress
                .removeClass( "current" )
                .addClass( "active" )
                .unbind( "click" )
                .bind( "click", function(e) {
					e.preventDefault();
                    checkout.nextStep( false, lastStep );
                } );
        }

        var nextAfterStepHandler = checkout.afterStepHandlers[ nextStepName ];
        if( nextAfterStepHandler ) { // used to toggle display for elements used on multiple steps
            nextAfterStepHandler.call();
        }

        $nextProgress.addClass( "current" );

        // show/hide skinny header/footer after first step
        if( nextStep > 0 ) {
            checkout.$progress.show();
            if (!checkout.user) { // keep normal header / footer for sales
                checkout.$fullHeader.hide();
                checkout.$fullFooter.hide();
                checkout.$skinnyHeader.show();
                checkout.$skinnyFooter.show();
            }
        }
        else {
            checkout.$progress.hide();
            checkout.$fullHeader.show();
            checkout.$fullFooter.show();
            checkout.$skinnyHeader.hide();
            checkout.$skinnyFooter.hide();
        }

        var nextStepCTA = checkout.stepCTAs[ nextStep ];
        checkout.$nextStep.attr('id', 'cta-' + nextStepCTA );

        var nextStepLabel = checkout.stepLabels[ nextStep ];
        checkout.$nextStep.html( nextStepLabel );

        checkout.session.set({
            'step': checkout.currentStepName()
        });

        // scroll to the top of the new page
        window.scrollTo( 0, 0 );

        // Call any step changed listeners
        checkout._callStepChangedListeners();
    };

    this.setLoginModal = function() {
        if( checkout.login ) {
            checkout.login.show();
        }
        else {
            checkout.login = new CheckoutV2.Login( checkout );
        }
    };

    this.setCart = function() {
        // if we're a guest and we went back to the cart,
        // give them the chance to log in again
        if(    checkout.login
            && checkout.login.guest
            ) {
            checkout.login.guest = false;
        }
        
        $('.paypal-option').show();
        
        return true;
    };
	
    this.setAfterCart = function() {
        if (checkout.user) {
            $('.main-section.js-shipping-options-widget.js-cart-contents').show();
        }

        if (checkout.cart && checkout.cart.saveForLater) {
            checkout.cart.saveForLater.toggleDisplay();
        }
    };

    this.setShippingAddress = function() {
        if ( !checkout.cart.validate() ) {
            checkout.cart.shipping.showValidateErrors();
            return false;
        }

		if( ! checkout.session.isLoggedIn()
            && ! checkout.login.guest
            ) {
            checkout.setLoginModal();
            return false;
        }

        if( ! checkout.shipinfo ) {
            checkout.shipinfo = new CheckoutV2.ShipInfo(
                checkout,
                '.js-shipping-address .js-address-form.js-shipping'
            );
        }

        if( checkout.session.isLoggedIn() ) {
            checkout.shipinfo.checkOriginalValues(); // throw away estimated values for logged in users and override with saved values

            if( checkout.shipinfo.validate() ) {
                // shipping address step is only for guest checkout,
                // skip this step if logged in
                checkout.nextStep( false, 2 );
                return false;
            }
            else if( checkout.shipinfo.stateRequest ) {
                // waiting on states to build
                checkout.cart.loading( "Validating Address" );
                setTimeout(
                    function() {
                        checkout.cart.loading( false );
                        checkout.nextStep( false, 1 );
                    },
                    10
                );
                return false;
            }
        }
        
        $('.paypal-option,.paypal-credit-option').hide();
        
        return true;
    };

    this.setShipping = function() {
        if( ! checkout.shipinfo ) {
            checkout.shipinfo = new CheckoutV2.ShipInfo(
                checkout,
                '.js-shipping-address .js-address-form.js-shipping'
            );
        }

        if( ! checkout.shipinfo.validate() ) {
            checkout.nextStep( false, 1 );
            return false;
        } else {
            checkout.shipinfo.setSessionDataFromForm();
        }
        
        $('.paypal-option,.paypal-credit-option').hide();

        return true;
    };
	
    this.setAfterShipping = function() {
        var addresses = checkout.config.shippingAddresses[0];
        var sessionShipping = checkout.session.get('shipping');

        if(    ! checkout.config.shippingAddresses
            || ! checkout.config.shippingAddresses[ 0 ]
            || ! checkout.config.shippingAddresses[ 0 ].ship_address
            ) {
            checkout.config.shippingAddresses = [ {
	            'ship_address'         : sessionShipping.address1,
	            'ship_address2'        : sessionShipping.address2,
	            'ship_city'            : sessionShipping.city,
	            'ship_company'         : sessionShipping.company,
	            'ship_country'         : sessionShipping.country,
                'ship_taxCode'         : sessionShipping.taxCode,
	            'ship_name_first'      : sessionShipping.firstname,
	            'ship_name_last'       : sessionShipping.lastname,
	            'ship_phone'           : sessionShipping.phone,
	            'ship_phone_alternate' : sessionShipping.phone_alternate,
	            'ship_state'           : sessionShipping.state,
	            'ship_zip'             : sessionShipping.zip,
	            'shipID'               : checkout.session.get('shipID'),
            } ];

	        var data = {
				currentShipID: checkout.session.get('shipID'),
				addresses: checkout.config.shippingAddresses
			};
	
	        $('.select-address-modal .address-list').html(
	            Jemplate.process('shippingAddressRows', data)
	        );
        }
		
        $('.js-shipping-options.js-shipping-options-widget').show();
    };
	
    this.setPayment = function() {
		// Do not step to payment if shipping method is not set
		if( !checkout.shipping.shippingMethod) {
			checkout.shipping.$shippingOptionsError = $('#shipping-options-error', checkout.shipping.$wrap);
			checkout.shipping.$shippingOptionsErrorMsg = $('.msg-text', checkout.shipping.$shippingOptionsError);
			checkout.shipping.$shippingOptionsErrorClose = $('.close', checkout.shipping.$shippingOptionsError);
			
			checkout.shipping.$shippingOptionsErrorMsg.html('Shipping option was not selected');
			checkout.shipping.$shippingOptionsError.show();
			
			// checkout.shipping.$shippingOptionsErrorClose.on('click', function() {
			// 	checkout.shipping.$shippingOptionsErrorMsg.html('');
			// 	checkout.shipping.$shippingOptionsError.hide();
			// });
			
			return false;
		}

		var billing = checkout.session.get('billing');
		var shipping = checkout.session.get('shipping');

		// There is an instance where a brand new session on a new user or newly created user does not have billing
		// info set after the shipping panel. We need to clone the shipping info into the session.
		if(!billing.address1 || billing.address1 === '') {
			Object.keys(billing).forEach(function(key){
				billing[key] = shipping[key];
			});
            checkout.session.set({'billing': billing});

            // prefill the billinfo form and render the billing address content for the new card display
			checkout.billinfo.buildContent();
            checkout.billinfo.displayBillingAddress();
		}

		// Toggles the payment method containers that either show the payment methods list or the
		// "Your balances cover the cost" message
		checkout.payment.togglePaymentMethodContainers();

		// When a user logs in from the modal, the session has not yet populated balances and credits.
		// By the time we get to payment, it has, so reinit the balances and credits stuff
        checkout.payment.showAvailableBalances();

        // The default button for payment should be the review button unless active methods have already set it
        if(!checkout.payment.activeMethods.length) {
            checkout.payment.setNextStepButtonHtml(checkout.getReviewStepButtonHtml());
		}

        if (   checkout.payment.currentPaymentMethod
            && checkout.payment.currentPaymentMethod.resetStep
            ) {
            checkout.payment.currentPaymentMethod.resetStep();
        }

        // check the payments again for validity
        checkout.payment.resetValidity();

        return true;
    };
	
	this.setReview = function() {
        if ( !checkout.payment.isValid()) {
            return false;
        }

        if(checkout.payment.hasThirdPartyPayment) {
        	// Hide any errors we might have had from paypal or affirm kicking back error codes on the
			// third party payment redirect
        	checkout.payment.hideErrors();

        	// Trigger the checkout loading overlay
        	if(checkout.payment.thirdPartyPaymentType === 'paypal') {
                checkout.loading('Sending you to PayPal...');
			} else if(checkout.payment.thirdPartyPaymentType === 'affirm') {
                checkout.loading('Sending you to Affirm...');
            }

            // Submit will detect which third party payment variables to set for the redirect
            checkout.submit();
        	return false;
		}

		// Ensure that the cart and shipping buttons are active. They need to be rebound when coming back from
		// a third party payment (paypal or affirm)
		if(!$('.js-progress-cart').hasClass('active')){
            $('.js-progress-cart')
				.removeClass( "current" )
                .addClass( "active" )
                .unbind( "click" )
                .bind( "click", function(e) {
                    e.preventDefault();
                    checkout.nextStep( false, 0 );
                } );
        }
        if(!$('.js-progress-shipping').hasClass('active')){
            $('.js-progress-shipping')
                .removeClass( "current" )
                .addClass( "active" )
                .unbind( "click" )
                .bind( "click", function(e) {
                    e.preventDefault();
                    checkout.nextStep( false, 2 );
                } );
        }
		
		$('.js-shipping-method').html(checkout.shipping.shippingMethod); // update review shipping method

		checkout.review.renderPaymentInfo();

		return true;
	};

	this.setSubmitOrder = function() {
        checkout.submit();
		return false;
	};
	
	this.stepNumberByName = function(stepName) {
		var stepNumber = 0;
		$.each(checkout.steps, function(i, step) {
			if (checkout.steps[i] == stepName) {
				stepNumber = i;
			}
		});
		return stepNumber;
	};
	
	this.currentStepName = function() {
		return checkout.steps[checkout.step];
	};
	
	this.loading = function(loadingMsg) {
		if (loadingMsg) {
			checkout.$loadingMsg.html(loadingMsg);
			checkout.$loadingOverlay.show().css('display', 'flex').removeClass('fade-out').addClass('fade-in');
		} else {
			checkout.$loadingOverlay.removeClass('fade-in').addClass('fade-out');
		}
	};
	
	this.keyRange = function(allowDecimal) {
		allowDecimal = (allowDecimal !== undefined) ? allowDecimal : false;
		var goodKeys = [];
		goodKeys.push.apply(goodKeys, checkout.specialKeys);
		for ( var i = 48; i <= 57; i++ ) {
			goodKeys.push(i);
		}
		for ( var i = 96; i <= 105; i++ ) {
			goodKeys.push(i);
		}
		if (allowDecimal) {
			var decimalKeys = [110, 190];
			goodKeys.push.apply(goodKeys, decimalKeys);
		}
		return goodKeys;
	}
	
	this.restrictNumbers = function(e) {
		var input = e.currentTarget;
		var $input = $(input);
		e.preventDefault();
		//console.log(e.keyCode, e.shiftKey);
		if( !checkout.numericKeys.includes(e.keyCode) || (checkout.numericKeys.includes(e.keyCode) && e.shiftKey) ) {
			if ( !(e.shiftKey && checkout.specialKeys.includes(e.keyCode)) ) {
				$input.val( $input.val().substr(0, $input.val().length - 1) );
				//console.log('bad!');
			}
		}
		
		// restrict input length in Chrome
		if (input.maxLength > 0 && $input.val().length > input.maxLength) {
			$input.val( $input.val().slice(0, input.maxLength) );
		}
	}
	
	this.restrictFloats = function(e) {
		var input = e.currentTarget;
		var $input = $(input);
		e.preventDefault();
		//console.log(e.keyCode, e.shiftKey);
		if( !checkout.floatKeys.includes(e.keyCode) || (checkout.floatKeys.includes(e.keyCode) && e.shiftKey) ) {
			if ( !(e.shiftKey && checkout.specialKeys.includes(e.keyCode)) ) {
				$input.val( $input.val().substr(0, $input.val().length - 1) );
				//console.log('bad!');
			}
		}
		
		// restrict input length in Chrome
		if (input.maxLength > 0 && $input.val().length > input.maxLength) {
			$input.val( $input.val().slice(0, input.maxLength) );
		}
	}
	
	this.shouldUseLargeFont = function() {
		/**
		  iPhone and iOS Form Input Zoom Fixes
		  when making changes also change www/static/assets/base/scss/components/_forms.scss, uses the same media queries
		*/
		var iOSMedia = [
			'screen and (min-device-width: 375px) and (max-device-height: 667px) and (-webkit-device-pixel-ratio: 2)', /* iphone 6, 6s, 7, 8 */
			'screen and (min-device-width: 414px) and (max-device-height: 736px) and (-webkit-device-pixel-ratio: 3)', /* iphone 6+, 6s+, 7+, 8+ */
			'screen and (min-device-width: 375px) and (max-device-height: 812px) and (-webkit-device-pixel-ratio: 3)', /* iphone 11 Pro, X, XS */
			'screen and (min-device-width: 414px) and (max-device-height: 896px) and (-webkit-device-pixel-ratio: 2)', /* iphone 11, XR */
			'screen and (min-device-width: 414px) and (max-device-height: 896px) and (-webkit-device-pixel-ratio: 3)'  /* iphone 11 Pro Max, XS Max */
		];
		checkout.useLargeFont = window.matchMedia(iOSMedia).matches;
	}

	this.init();
};
